module.exports = __webpack_public_path__ + "images/logo_menu_narrow.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/logo_menu_narrow.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/logo_menu_narrow.svg
// module chunks = site__mhf